<template>
  <!-- İçerik document.body'ye taşınır (bootstrap-vue'nun modal taşıyıcısı gibi): animate.css
       transform'ları ve #content-page'in stacking context'i position: fixed'i bozmasın.
       `.est-body-portal` hep render edilir (smoke seçicileri `body > .est-body-portal`). -->
  <Teleport to="body">
    <div class="est-body-portal"><slot /></div>
  </Teleport>
</template>

<script>
  export default {
    name: 'BodyPortal'
  };
</script>
